import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'link-dashed',
  templateUrl: 'link-dashed.component.html',
  styleUrls: ['link-dashed.component.scss']
})
export class LinkDashedComponent {
  @Input() href: string;
  @Input() title: string;
  @Input() linkText: string;
  @Input() target: string = '_blank';
}
